import React from "react";
import "../styles/Experience.css";
import Banner from "../components/Banner";

function Experience() {
    return (
      <div className="Experience">
        <Banner />
        <div className="skills">
          <h1>Skills</h1>
          <ol className="list">
            <li className="item">
              <h2>Languages</h2>
              <span>C++,   Java,   Python,   JavaScript,   R,   GLSL,   SQL</span>
            </li>
            <li className="item">
              <h2>Development Tools</h2>
              <span>
                g++, Git Bash, GitHub, Jupyter Notebook, MariaDB,
                Visual Studio Code, Docker, JUnit, npm, yarn, pip
               </span>
            </li>
            <li className="item">
              <h2>Front-End</h2>
              <span>ReactJS, HTML, CSS</span>
            </li>
            <li className="item">
              <h2>Back-End</h2>
              <span>NodeJS, ExpressJS, PostgreSQL, MongoDB, Strappi, Docker</span>
            </li>
          </ol>
        </div>
      </div>
    );
  }
  

export default Experience;